import React, { ReactNode, useCallback, useState } from 'react';

import AngleDown from '../icon/regular/AngleDown';

export default function Panel({ header, children }: { header: string, children: ReactNode }) {
  const [isActive, setIsActive] = useState(true);

  const handleToggleClick = useCallback(() => {
    setIsActive(!isActive);
  }, [isActive, setIsActive]);

  return (
    <div className={`${isActive ? 'active ' : ''}group/filter`}>
      <button
        className="flex gap-3 justify-between w-full py-3.25 lg:py-3.5 pe-3 lg:pe-3.75 font-semibold text-gray-950 lg:text-xl border-dashed-bottom cursor-pointer"
        type="button"
        onClick={handleToggleClick}
      >
        {header}
        <AngleDown className="w-4 lg:w-3 fill-pink-400 group-[.active]/filter:rotate-180" />
      </button>
      <div className="hidden group-[.active]/filter:block pt-3 lg:pt-2 pb-7.75 lg:pb-10">
        {children}
      </div>
    </div>
  );
}
